import React from "react";
import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 650,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },

  grid: {
    "& .makeStyles-root-65": { minHeight: "430px !important" },
  },
  multiselectConfigFileCompression: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "35px",
      overflow: "auto",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
  subHeadings: {
    fontSize: "14px",
  },
  remarksDiv: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  totalDiv: {
    marginBottom: "10px",
    backgroundColor: "#6697e2",
    padding: "10px",
    borderRadius: "5px",
    color: "black",
    width: "81%",
    marginTop: "115px",
    position: "fixed",
    bottom: "0",
  },
  totalVal: { fontWeight: "bold" },

  readOnyTitle: {
    fontWeight: "bold",
    fontSize: "13px",
  },
}));
